import React from 'react'
import Navbar from './Navbar';
import './css/Download.css';

const Download = () => {
    return (
        <>
            <Navbar />
            <section id="welcome-section" className="welcome-section">
                <h1>Downloads</h1>
            </section>

            <section id="projects" className="projects-section">
                <h2 className="projects-section-header">Download list</h2>

                <div className="projects-grid">
                    <a target="_blank" className="project project-tile">
                        <img className="project-image" src="" alt="project" />
                        <p className="project-title">
                            <span className="download-list-menu">Speciality Chemicals</span>
                        </p>
                    </a>
                    <a target="_blank" className="project project-tile">
                        <img className="project-image" src="" alt="project" />
                        <p className="project-title">
                            <span className="download-list-menu">Biologistic Catelogue</span>
                        </p>
                    </a>
                    <a target="_blank" className="project project-tile">
                        <img className="project-image" src="" alt="project" />
                        <p className="project-title">
                            <span className="download-list-menu">ASPL company bank details</span>
                        </p>
                    </a>
                    <a target="_blank" className="project project-tile">
                        <img className="project-image" src="" alt="project" />
                        <p className="project-title">
                            <span className="download-list-menu">Holiday List</span>
                        </p>
                    </a>
                </div>

            </section>

            <section id="contact" className="contact-section">
                <div className="contact-section-header">
                    <h2>Contact Details</h2>
                </div>
                <div className="contact-links">
                    <a target="_blank" className="button contact-details"><i className="fab fa-facebook-square"></i> Facebook</a>
                    <a id="profile-link" target="_blank" className="button contact-details"><i className="fab fa-github"></i> GitHub</a>
                    <a target="_blank" className="button contact-details"><i className="fab fa-twitter"></i> Twitter</a>
                    <a className="button contact-details"><i className="fas fa-at"></i> Send a mail</a>
                    <a className="button contact-details"><i className="fas fa-mobile-alt"></i> Call me</a>
                </div>
            </section>

            <footer>
                <p className="text-for-footer">
                    Copyright 2020 © by Jivichem Synthesis Private Limited. All Rights
                    Reserved
                </p>
                <p className="text-for-footer">
                    <a target="_blank">
                        Powered by : Gagri Global IT Services Pvt. Ltd.
                    </a>
                </p>
            </footer>

        </>
    )
}
export default Download;
